import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// Webpack dev server ResizeObserver error is now suppressed in public/index.html

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Automatically append store_id to POST/PUT requests if a branch user is logged in
    if (['post', 'put', 'patch'].includes(config.method)) {
      const store_id = localStorage.getItem('store_id');
      if (store_id && store_id !== "0") {
        if (config.data instanceof FormData) {
          if (!config.data.has('store_id')) {
             config.data.append('store_id', store_id);
          }
        } else if (typeof config.data === 'object' && config.data !== null && !Array.isArray(config.data)) {
          config.data = {
             ...config.data,
             store_id: config.data.store_id !== undefined ? config.data.store_id : Number(store_id),
          };
        } else if (!config.data) {
          config.data = { store_id: Number(store_id) };
        }
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    // Check if the backend returned our custom unauthorized code
    if (response.data && response.data.code === 701) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
